import { Component, OnInit } from '@angular/core';
import { SecurityService } from 'src/app/api/security.service';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'auth-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  loading = false;
  error: string = null;
  success = false;

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  constructor(private fb: FormBuilder, private securityService: SecurityService) { }

  ngOnInit() {
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.error = null;
      this.success = false;

      this.securityService.requestPasswordReset(this.email.value).subscribe(response => {
        this.loading = false;
        this.success = response;
        this.form.reset();
      }, err => {
        this.loading = false;
        this.error = err.errors[0].message;
      });
    } else {
      this.error = 'invalid email';
    }
  }

  get email() { return this.form.get('email'); }
}
